import { createSlice } from '@reduxjs/toolkit';
import { MODALS_KEYS } from '_constants/modals';

const modalsSlice = createSlice({
  name: 'modals',
  initialState: {
    visibility: {
      [MODALS_KEYS.paymentFailed]: false,
    },
  },
  reducers: {
    showModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload]: true,
      };
    },
    hideModal(state, action) {
      state.visibility = {
        ...state.visibility,
        [action.payload]: false,
      };
    },
  },
});

export const { showModal, hideModal } = modalsSlice.actions;

export default modalsSlice.reducer;
